// extracted by mini-css-extract-plugin
export default {"title":"AttachmentFiles__title--XSo30","tabContent":"AttachmentFiles__tabContent--xf4ff"};